export default "__VITE_ASSET__d71ecccd__"